import { render } from "./NewsCreate.vue?vue&type=template&id=719ebb06&scoped=true"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"

import "./NewsCreate.vue?vue&type=style&index=0&id=719ebb06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719ebb06"]])

export default __exports__